import React from "react";
import FormCard from "../Components/FormCard";
import style from "./../styles/RegisterShop.module.css";
import { Button, Form, Row, Col, Spinner } from "react-bootstrap";
import axios from "axios";
import { useState, useEffect } from "react";
import { default as ReactSelect } from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCross } from "@fortawesome/free-solid-svg-icons";
import PopUpModal from "../Components/Modal";
import Loader from "../Components/Loader";
import styleModal from "./../styles/Modal.module.css";
import ImageUploader from "../Components/ImageUploader/ImageUploader";
import { useRef } from "react";
import PhoneInput from "../Components/PhoneInput/PhoneInput";
import CnicInput from "../Components/CnicInput/CnicInput";
import { useSelector } from "react-redux";
import Map from "../Components/Map";
import useApi from "../Hooks/useApi";
import * as api from "../api/getapi";
import SearchableSelect from "../Components/SearchableSelect";

const RegisterShop = () => {
  const { user } = useSelector((state) => state.auth);
  const userId = user.user_id;
  const [shop_name, setShopName] = useState("");
  const [usernameError, setUserNameError] = useState();
  const [userName, setUserName] = useState("");
  const [shop_owner_name, setShopOwnerName] = useState("");
  const [shop_address, setShopAddress] = useState("");
  const [owner_CNIC, setOwnerCNIC] = useState("");
  const [owner_email, setEmail] = useState("");
  const [owner_whatsapp_number, setOwnerWhatsappNumber] = useState("");
  const [owner_backup_phone_number, setOwnerBackupPhoneNumber] = useState("");
  const [on_trial, setTrial] = useState(false);
  const [on_payment, setPayment] = useState(false);
  const [trial_till_date, setTrialTillDate] = useState("");
  const [province, setProvince] = useState(null);
  const [provinceList, setProvinceList] = useState([]);
  const [city, setCity] = useState(null);
  const [cityList, setCityList] = useState([]);
  const [trialOrPayment, setTrialOrPayment] = useState("");
  const [plans, setPlans] = useState();
  const [error, setError] = useState("");
  const [trialPaymentError, setTrialPaymentError] = useState(false);
  const [success, setSuccess] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [isClicked, setIsclicked] = useState(false);
  const [nameLoader, setNameLoader] = useState(false);
  const [daysField, setDaysField] = useState([]);
  const [selectPlan, setSelectPlan] = useState({});
  const [coords, setCoords] = useState({ lat: 0, lng: 0 });
  const [isLocationSelected, setIsLocationSelected] = useState(false);

  // States for Custom Plan
  const [planAmount, setPlanAmount] = useState("");
  const [itemsLimit, setItemsLimit] = useState("");
  const [locationLimit, setLocationLimit] = useState("");
  const [emailsLimit, setEmailsLimit] = useState("");
  const [smsLimit, setSmsLimit] = useState("");
  const [yearlyTotal, setYearlyTotal] = useState("");
  const [monthlyTotal, setMonthlyTotal] = useState(0);
  const [quarterlyTotal, setQuarterlyTotal] = useState("");
  const [semiannualTotal, setSemiannualTotal] = useState("");
  const [secondaryUsersLimit, setSecondaryUsersLimit] = useState("");
  const [modulesOptions, setModulesOptions] = useState([]);
  const [p_id, setP_id] = useState();
  const [theme, setTheme] = useState();
  const [prices, setPrices] = useState([]);
  const [customPrices, setCustomPrices] = useState({
    secondaryUsersTotal: 0,
    marketplaceThemeTotal: 0,
    smsTotal: 0,
    emailTotal: 0,
    locationLimitTotal: 0,
    modulesTotal: 0,
    themesTotal: 0,
    itemsTotal: 0,
    yearlyTotal: 0,
    monthlyTotal: 0,
    quarterlyTotal: 0,
  });
  const [customForm, setCustomForm] = useState({
    planName: "",
    planType: "",
    planAmount: "",
    shop: "",
    itemsLimit: "",
    emailsLimit: "",
    smsLimit: "",
    locationLimit: "",
    yearlyTotal: 0,
    monthlyTotal: 0,
    quarterlyTotal: 0,
    primaryUser: "",
    secondaryUser: "",
    themes: [],
    modules: [],
    submodules: [],
  });
  const modulesNotShow = ["Dashboard", "Employees", "Customer", "GeneralReport", "Settings", "LocationList", "Banks", "SystemSettings", "Subscriptions"];
  const modulesAlwaysChecked = ["Dashboard", "GeneralReport", "Customer", "Reports", "Settings", "LocationList", "Banks", "SystemSettings", "Subscriptions", "Employees"];

  const getParent = useApi(api.getParentModules);
  const getPricess = useApi(api.fetchAllConsumableItems);
  const FetchAllThemes = useApi(api.getAllThemes);

  const fetchModulesData = async () => {
    try {
      const data = await getParent.request(0);
      let val = data.data.map((item) => {
        return { ...item, checked: modulesAlwaysChecked.includes(item.name), disabled: modulesAlwaysChecked.includes(item.name), submodulesArray: item.submodulesArray.map((submodule) => ({ ...submodule, checked: modulesAlwaysChecked.includes(submodule.name) })) };
      });
      setModulesOptions(val);
    } catch (error) {
      console.log(error);
    }
  };
  const getThemes = async () => {
    await FetchAllThemes.request().then((res) => {
      setTheme(res?.data?.data);
    });
  };
  const fetchSubModulesData = async (id) => {
    setP_id(id);
  };
  const handleCheckboxChange = (e, name) => {
    e.stopPropagation();
    const isChecked = e.target.checked;
    setModulesOptions((prev) =>
      prev.map((item, i) => {
        if (item.name === name) {
          // Update custom prices based on the checkbox stat

          // Update the checked state of the item
          return { ...item, checked: isChecked };
        }
        return item;
      }),
    );

    if (!isChecked) {
      // Uncheck all submodules when the parent module is unchecked
      setModulesOptions((prev) => {
        return prev.map((item, i) => {
          if (item.name === name) {
            return {
              ...item,
              submodulesArray: item.submodulesArray.map((subItem) => ({
                ...subItem,
                checked: false,
              })),
            };
          }
          return item;
        });
      });
    }
  };
  const getItemsPrices = async () => {
    getPricess
      .request()
      .then((res) => {
        setPrices(res.data.data.consumableItems);
      })
      .catch((err) => {
        throw new Error(err);
      });
  };

  const handleSelectPlanChange = (e, name) => {
    if (name === "themes") {
      setCustomForm({ ...customForm, [name]: e });
    }
    setCustomForm({ ...customForm, [name]: e });
  };

  const ThemeOptions = theme?.map((cat) => ({ value: cat.id, label: cat.theme_name, price: cat.price }));

  useEffect(() => {
    getThemes();
    fetchModulesData();
    getItemsPrices();
  }, []);
  const handleSubmoduleCheckboxChange = (e, name, pName) => {
    const parentModule = modulesOptions.find((item) => item.name === pName);
    if (parentModule?.checked ? parentModule?.checked : false) {
      setModulesOptions((prevModulesOptions) => {
        return prevModulesOptions.map((module, i) => {
          if (module.name === pName) {
            return {
              ...module,
              submodulesArray: module.submodulesArray.map((item, subIndex) => {
                if (item.name === name) {
                  return { ...item, checked: e.target.checked };
                }
                return item;
              }),
            };
          }
          return module;
        });
      });
    } else {
      alert("Please select Parent Module first");
    }
  };
  const handlePlanChange = (e) => {
    const { name, value } = e.target;
    if (name === "planAmount" || name === "itemsLimit" || name === "emailsLimit" || name === "smsLimit" || name === "locationLimit") {
      value.replace(/\D/g, "");
    }
    setCustomForm({ ...customForm, [name]: value });
  };

  const ImageRef = useRef();
  const [image, setImage] = useState({});

  const [validated, setValidated] = useState(false);
  const [billingPeriod, setBillingPeriod] = useState({
    value: "quarterly",
    label: "Quarterly",
  });

  const handleRadio = (e) => {
    setTrialPaymentError(false);
    if (e.target.value === "on_trial") {
      setTrial(true);
      setTrialOrPayment("onTrial");
      setPayment(false);
    } else {
      setTrial(false);
      setPayment(true);
      setTrialOrPayment("onPayment");
    }
  };

  const daysOptions = [
    { value: "mon", label: "Mon" },
    { value: "tue", label: "Tue" },
    { value: "wed", label: "Wed" },
    { value: "thur", label: "Thu" },
    { value: "fri", label: "Fri" },
    { value: "sat", label: "Sat" },
    { value: "sun", label: "Sun" },
  ];
  const handleChange = (selected) => {
    setDaysField(selected);
  };

  useEffect(() => {
    const getprovince = async () => {
      try {
        const res = await axios.get(process.env.REACT_APP_API_URL + "/location/get-province", { withCredentials: true });
        const data = res.data.map((p) => ({
          value: p.province_id,
          label: p.province_name,
        }));
        setProvinceList(data);
      } catch (error) {
        throw new Error(error);
      }
    };
    getprovince();
  }, []);

  const handleprovince = (event) => {
    setProvince(event);
  };

  useEffect(() => {
    const getcity = (id) => {
      axios
        .get(process.env.REACT_APP_API_URL + `/location/get-city/${id}`, {
          withCredentials: true,
        })
        .then((res) => {
          const data = res.data.map((c) => ({
            value: c.city_id,
            label: c.city_name,
          }));
          setCityList(data);
        })
        .catch((err) => {
          throw new Error(err);
        });
    };
    if (province?.value) {
      getcity(province?.value);
    }
  }, [province?.value]);

  const handlecity = (event) => {
    setCity(event);
  };

  const handleShopName = (e) => {
    setShopName(e.target.value.replace(/[^\w\s]/gi, ""));
  };

  const handleUser = (e) => {
    let username = e.target.value;
    username = username.replace(/\s+/g, "-").toLowerCase();
    username = username.replace(/\./g, "");
    username = username.replace(/\//g, "");
    setUserName(username);
    axios
      .post(process.env.REACT_APP_API_URL + `/shops/is-username-available`, { username: username }, { withCredentials: true })
      .then((res) => {
        if (res.data === false) {
          setUserNameError(true);
        } else {
          setUserNameError(false);
        }
      })
      .catch((err) => {
        throw new Error(err);
      });
  };

  const handleUserName = async () => {
    try {
      setNameLoader(true);
      var username = shop_name.trim();
      username = username.replace(/\s+/g, "-").toLowerCase();
      username = username.replace(/\./g, " ");
      username = username.replace(/\//g, " ");
      let i = 1;
      let res = await axios.post(process.env.REACT_APP_API_URL + `/shops/is-username-available`, { username: username }, { withCredentials: true });
      if (res.data === false) {
        while (res.data === false) {
          res = await axios.post(process.env.REACT_APP_API_URL + `/shops/is-username-available`, { username: username }, { withCredentials: true });
          if (res.data === true) {
            setUserNameError(false);
            setUserName(username);
            setNameLoader(false);
          }
          var x = username.match(/[^\d]+|\d+/g);
          username = x[0] + (Number(i) + 1);
          i++;
        }
      } else {
        setUserNameError(false);
        setUserName(username);
        setNameLoader(false);
      }
    } catch (error) {
      throw new Error(error);
    }
  };

  // Subscriptions
  useEffect(() => {
    if (on_trial === true || on_payment === true) {
      let planType;
      if (on_trial === true) {
        planType = "trial";
      } else if (on_payment === true) {
        planType = "fixed";
        axios
          .post(process.env.REACT_APP_API_URL + `/plans/get`, { planType }, { withCredentials: true })
          .then((res) => {
            const plandResData = res.data.map((data) => ({
              value: data.plan_id,
              label: data.plan_name,
            }));
            setPlans([...plandResData, { value: "custom", label: "Custom" }]);
          })
          .catch((err) => {
            throw new Error(err);
          });
      }
    }
  }, [on_trial, on_payment]);

  useEffect(() => {
    changeAmounts(planAmount);
  }, [planAmount, billingPeriod]);

  const extractIds = (data) => {
    const ids = [];
    data.forEach((mainObj) => {
      if (mainObj.checked) {
        ids.push(mainObj.id);
      }
      mainObj.submodulesArray.forEach((submodule) => {
        if (submodule.checked) {
          ids.push(submodule.id);
        }
      });
    });
    return ids;
  };
  const d = new Date();
  const addDate = d.setDate(d.getDate() + 10);
  const maxDate = new Date(addDate).toISOString().split("T")[0];

  async function submit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    }
    if (on_trial === false && on_payment === false) {
      setTrialPaymentError(true);
    } else {
      setTrialPaymentError(false);
    }
    try {
      setValidated(true);

      let state;
      if (selectPlan?.value === "custom") {
        if (customForm.planAmount !== "" && modulesOptions.find((module) => module.name === "Marketplace")?.checked ? customForm.itemsLimit !== "" : true && customForm.emailsLimit !== "" && customForm.locationLimit !== "" && customForm.smsLimit !== "" && customForm.secondaryUser !== "") {
          state = true;
        } else {
          state = false;
        }
      } else {
        state = true;
      }
      if (usernameError === false && (on_trial === true || on_payment === true) && (trial_till_date.length > 0 || (Object.values(selectPlan).length > 0 && Object.values(billingPeriod).length > 0)) && daysField.length > 0 && province?.value > 0 && city?.value > 0 && isLocationSelected && state) {
        setIsclicked(true);
        var data = "";
        if (Object.values(image).length > 0) {
          data = await ImageRef.current.uploadImage();
        }
        const shopObj = {
          registered_by: userId,
          moderator: userId,
          shop_name,
          username: userName,
          shop_owner_name,
          shop_address,
          owner_CNIC,
          owner_email,
          owner_whatsapp_number,
          owner_backup_phone_number,
          on_trial,
          on_payment,
          trial_till_date: on_trial ? trial_till_date : "1000-01-01",
          logo_path: data.length > 0 ? data : null,
        };
        const locationObj = {
          province_id: province?.value,
          city_id: city?.value,
          shop_working_days: JSON.stringify(daysField.map((day) => day.value)),
          latitude: coords?.lat,
          longitude: coords?.lng,
        };
        let plansObj;
        if (on_trial) {
          plansObj = {};
        } else if (on_payment) {
          if (selectPlan?.value === "custom") {
            plansObj = {
              plan_type: "custom",
              plan_amount: customForm.planAmount,
              marketplace_items_limit: +customForm.itemsLimit,
              // locations_limit: locationLimit,
              // emails_limit: emailsLimit,
              // sms_limit: smsLimit,
              emails_limit: +customForm.emailsLimit,
              locations_limit: +customForm.locationLimit,
              sms_limit: +customForm.smsLimit,
              secondary_users_limit: +customForm.secondaryUser,

              // secondary_users_limit: secondaryUsersLimit,
              monthly_grand_total: monthlyTotal,
              quarterly_grand_total: quarterlyTotal,
              semiannual_grand_total: semiannualTotal,
              yearly_grand_total: yearlyTotal,
              billing_period: billingPeriod?.value,
              modules: extractIds(modulesOptions),
              ...(modulesOptions.find((module) => module.name === "Marketplace")?.checked && { themes: customForm.themes?.map((cat) => cat.value) }),
            };
          } else {
            plansObj = {
              plan: selectPlan?.value,
              billing_period: billingPeriod?.value,
            };
          }
        }
        const res = await axios.post(
          process.env.REACT_APP_API_URL + "/shops/register-shop",
          {
            shop: shopObj,
            location: locationObj,
            plan: plansObj,
          },
          { withCredentials: true },
        );
        setSuccess(res.data.success.message);
        setModalShow(true);
        setTimeout(() => setModalShow(false), 1500);
        setIsclicked(false);
        setValidated(false);
        if (res.data) {
          setShopName("");
          setUserName("");
          setUserNameError();
          setShopOwnerName("");
          setShopAddress("");
          setOwnerCNIC("");
          setEmail("");
          setOwnerWhatsappNumber("");
          setOwnerBackupPhoneNumber("");
          setTrial(false);
          setPayment(false);
          setTrialTillDate("");
          setCity(null);
          setProvince(null);
          setTrialOrPayment("");
          setDaysField([]);
          setImage([]);
          setError("");
          setTrialPaymentError(false);
          setSelectPlan({});
          setPlanAmount("");
          setItemsLimit("");
          setEmailsLimit("");
          setLocationLimit("");
          setSmsLimit("");
          setQuarterlyTotal("");
          setMonthlyTotal(0);
          setYearlyTotal("");
          setSemiannualTotal("");
          setSecondaryUsersLimit("");
          // setCoords({lat: 0, lng: 0})
        }
      }
    } catch (error) {
      setIsclicked(true);
      setError(error?.response?.data?.error?.message);
      setIsclicked(false);
    }
  }

  const calculate = () => {
    let total = 0;
    modulesOptions.forEach((module) => {
      if (module.checked) {
        total = total + Number(module.price);
        module.submodulesArray.forEach((subModule) => {
          if (subModule.checked) {
            total = total + Number(subModule.price);
          }
        });
      }
    });
    customForm.themes.forEach((theme) => {
      total = total + Number(theme.price);
    });
    const limitNameMapping = {
      itemsLimit: "marketplace_items_limit",
      smsLimit: "sms_limit",
      emailsLimit: "emails_limit",
      locationLimit: "locations_limit",
      secondaryUser: "secondary_users_limit",
      // Add other mappings if needed
    };

    Object.keys(limitNameMapping).map((val) => {
      const limitName = limitNameMapping[val];
      if (limitName) {
        prices.forEach((price) => {
          if (price.name === limitName) {
            const newAmount = price.per_unit_price * customForm[val];
            total = total + newAmount;
          }
        });
        // const newAmount = prices[limitName].per_unit_price * customForm[val];
        // total = total + newAmount;
      }
    });

    setCustomForm((prev) => ({ ...prev, planAmount: total }));
    if (customForm.planType?.value !== "trial") {
      changeAmounts(total);
    }
  };
  const changeAmounts = (amount) => {
    if (amount) {
      const price = Math.round(Number(amount));
      setQuarterlyTotal(Math.round(price * 3));
      setSemiannualTotal(Math.round(price * 6 * 0.9));
      setYearlyTotal(Math.round(price * 12 * 0.8));
      setMonthlyTotal(price);
    }
  };
  return (
    <div className="w-100">
      <div className={`d-flex justify-content-center align-items-center ${style.wrapper}`}>
        <FormCard>
          <h4 className="mt-5 mb-4 text-center fw-bold">Sign Up</h4>
          {error && <span className="text-danger p-2 text-center my-2 rounded-1">*{error}</span>}
          {
            <PopUpModal
              icon={<FontAwesomeIcon icon={success ? faCircleCheck : faCross} />}
              text={success ? success : error}
              type={success ? styleModal.successBg : styleModal.errorBg}
              iconModal={success ? styleModal.successIcon : styleModal.errorIcon}
              show={modalShow}
              onHide={() => setModalShow(false)}
            />
          }
          {/* {error && <span className="text-danger p-2 text-center my-2 rounded-1">*{error}</span>} */}
          <Form noValidate validated={validated} onSubmit={submit}>
            <Row>
              <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="formBasicShopName">
                <label>
                  Shop Name <span className="text-danger">*</span>
                </label>
                <Form.Control
                  className="p-2"
                  name="shop_name"
                  type="text"
                  placeholder="Shop Name"
                  onKeyDown={(e) => ["!", "#", "$", "%", "^", "&", "*", "(", ")", ":", "'", "/", "`", "{", "}", "[", "]", "~", "+", "@", "_"].includes(e.key) && e.preventDefault()}
                  value={shop_name}
                  onChange={(e) => handleShopName(e)}
                  required
                />
                <Form.Control.Feedback type="invalid">* Please Enter Shop Name</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className={`my-2 ${style.usernameInput}`} as={Col} lg="6" md="6" sm="12" controlId="formBasicShopName">
                <label>
                  Username <span className="text-danger">*</span>
                </label>
                <Form.Control
                  className={`p-2`}
                  name="shop_name"
                  type="text"
                  placeholder="Username"
                  onKeyDown={(e) => ["!", "#", "$", "%", "^", "&", "*", "(", ")", ":", "'", "/", "`", "{", "}", "[", "]", "~", "+", "@"].includes(e.key) && e.preventDefault()}
                  value={userName}
                  onChange={(e) => handleUser(e)}
                  required
                />
                <div className={`${style.generateButton}`}>
                  <Button onClick={() => handleUserName()} style={{ width: "40px", height: "40px" }} className={`${style.gButton} rounded-0 d-flex justify-content-center align-items-center`}>
                    {nameLoader === true ? <Spinner animation="border" size="sm" /> : "@"}
                    {/* <FontAwesomeIcon className="text-white" icon={faEye} /> */}
                  </Button>
                </div>
                <Form.Control.Feedback type="invalid">* Please Enter Username</Form.Control.Feedback>
                {usernameError === true && <span style={{ color: "rgba(240, 104, 129, 1)" }}>Username Already Exists</span>}
                {usernameError === false && userName !== "" && <span style={{ color: "rgba(36, 153, 62, 1)" }}>Username is available</span>}
              </Form.Group>
              <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="formBasicName">
                <label>
                  Owner Name <span className="text-danger">*</span>
                </label>
                <Form.Control
                  className="p-2"
                  name="shop_owner_name"
                  type="text"
                  placeholder="Owner Name"
                  onKeyDown={(e) => ["!", "#", "$", "%", "^", "&", "*", "(", ")", ":", "'", "/", "`", "{", "}", "[", "]", "~", "+", "@", "_", "-"].includes(e.key) && e.preventDefault()}
                  value={shop_owner_name}
                  onChange={(e) => setShopOwnerName(e.target.value)}
                  required
                />
                <Form.Control.Feedback type="invalid">* Please Enter Owner Name</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="formBasicEmail">
                <label>
                  Owner's Email <span className="text-danger">*</span>
                </label>
                <Form.Control className="p-2" name="owner_email" type="email" placeholder="example@gmail.com" value={owner_email} onChange={(e) => setEmail(e.target.value)} required />
                <Form.Control.Feedback type="invalid">* Please Enter Valid Email Address</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="my-2" as={Col} lg="12" md="12" sm="12" controlId="formBasicAddress">
                <label>
                  Address <span className="text-danger">*</span>
                </label>
                <Form.Control className="p-2" name="address" type="text" placeholder="Type Address" value={shop_address} onChange={(e) => setShopAddress(e.target.value)} required />
                <Form.Control.Feedback type="invalid">* Please Enter Shop Address</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12">
                <label>
                  Province <span className="text-danger">*</span>
                </label>
                <ReactSelect placeholder="Select Province" options={provinceList} value={province} onChange={(e) => handleprovince(e)} />
                <Form.Control className="p-2" name="province" hidden type="text" value={province?.value > 0 ? province?.value : ""} onChange={() => {}} required />
                <Form.Control.Feedback type="invalid">* Please Select Province</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12">
                <label>
                  City <span className="text-danger">*</span>
                </label>
                <ReactSelect placeholder="Select City" options={cityList} value={city} onChange={(e) => handlecity(e)} />
                <Form.Control className="p-2" name="city" hidden type="text" value={city?.value > 0 ? city?.value : ""} onChange={() => {}} required />
                <Form.Control.Feedback type="invalid">* Please Select City</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="formBasicCNIC">
                <label>
                  CNIC Number <span className="text-danger">*</span>
                </label>
                <CnicInput value={owner_CNIC} onChange={(e) => setOwnerCNIC(e.target.value)} placeholder="XXXXX-XXXXXXX-X" required />
                <Form.Control.Feedback type="invalid">* Please Enter Your CNIC</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="formBasicNumber">
                <label>
                  Whatsapp Number <span className="text-danger">*</span>
                </label>
                <PhoneInput placeholder="+92-3XX-XXXXXXX" value={owner_whatsapp_number} onChange={(e) => setOwnerWhatsappNumber(e.target.value)} required />
                <Form.Control.Feedback type="invalid">* Please Enter Correct Whatsapp Number</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="formBasicEmail">
                <label className="mb-1">
                  Backup Number <span className="text-secondary">(Optional)</span>
                </label>
                <PhoneInput className="p-2" type="number" placeholder="+92-3XX-XXXXXXX" value={owner_backup_phone_number} onChange={(e) => setOwnerBackupPhoneNumber(e.target.value)} pattern="^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$" />
                <Form.Control.Feedback type="invalid">* Please Enter Correct Number</Form.Control.Feedback>
              </Form.Group>
              <Col className="mt-2 mb-3" lg="6" md="6" sm="12">
                <label className="mb-1">
                  Shop Working Days <span className="text-danger">*</span>
                </label>
                <div className={style.multiSelect}>
                  <ReactSelect classNamePrefix="react-select-container" options={daysOptions} isMulti closeMenuOnSelect={false} onChange={handleChange} value={daysField} name="shop_working_days" />
                </div>
                <Form.Control className="p-2" name="workingDays" hidden type="text" value={daysField.length > 0 ? daysField : ""} onChange={() => {}} required />
                <Form.Control.Feedback type="invalid">* Please Select Shop Working Days</Form.Control.Feedback>
              </Col>
            </Row>
            <Map coords={coords} setCoords={setCoords} isLocationSelected={isLocationSelected} setIsLocationSelected={setIsLocationSelected} />
            <div className={`${style.fullWidth} ${style.hr} mt-2`}></div>
            <div className={`${style.fullWidth} my-3`}>
              <div className={`${style.flexRadio}`}>
                <div className={`${style.radiolabel}`}>
                  <Form.Check className={`${style.radio}`} name="trailOrPayment" value="on_trial" type="radio" id="onTrial" aria-label="radio Trial" onClick={handleRadio} checked={trialOrPayment === "onTrial"} />
                  <label htmlFor="Trial">On Trial</label>
                </div>
                <div className={`${style.radiolabel}`}>
                  <Form.Check className={`${style.radio}`} name="trailOrPayment" value="on_payment" type="radio" id="onPayment" aria-label="radio Payment" onClick={handleRadio} checked={trialOrPayment === "onPayment"} />
                  <label htmlFor="Payment">On Payment</label>
                </div>
              </div>
              {trialPaymentError && (
                <div className="mt-2" style={{ color: "#DC3545" }}>
                  * Please select On Trial or On Payment
                </div>
              )}
            </div>
            <Row className={`mb-3 ${style.trialDateInput}`}>
              {trialOrPayment === "onTrial" && (
                <Form.Group as={Col} lg="6" md="6" sm="12">
                  <label className="mb-1">
                    On Trial Till <span className="text-danger">*</span>
                  </label>
                  <Form.Control className="p-2" type="date" placeholder="Select Date" min={maxDate} value={trial_till_date} onChange={(e) => setTrialTillDate(e.target.value)} required={on_trial === true ? true : false} />
                  <Form.Control.Feedback type="invalid">* Please Enter Trial Till Date</Form.Control.Feedback>
                </Form.Group>
              )}
              {trialOrPayment === "onPayment" && (
                <>
                  <Form.Group className="mb-3" as={Col} lg="6" md="6" sm="12">
                    <label className="mb-1">
                      Plans <span className="text-danger">*</span>
                    </label>
                    <ReactSelect
                      className="text-capitalize"
                      placeholder="Select Plan"
                      options={plans}
                      onChange={(e) => {
                        setSelectPlan(e);
                      }}
                    />
                    <Form.Control className="p-2" name="plan" hidden type="text" value={Object.keys(selectPlan).length > 0 ? selectPlan : null} onChange={() => {}} required={on_payment === true ? true : false} />
                    <Form.Control.Feedback type="invalid">* Please Select Plan</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-3" as={Col} lg="6" md="6" sm="12">
                    <label className="mb-1">
                      Billing Period <span className="text-danger">*</span>{" "}
                    </label>
                    <ReactSelect
                      placeholder="Select Billing Period"
                      options={[
                        { value: "quarterly", label: "Quarterly" },
                        { value: "semiannual", label: "Semiannual" },
                        { value: "yearly", label: "Yearly" },
                      ]}
                      defaultValue={billingPeriod}
                      value={billingPeriod}
                      onChange={(e) => setBillingPeriod(e)}
                    />
                    <Form.Control className="p-2" name="billingPeriod" hidden type="text" value={Object.keys(billingPeriod).length > 0 ? billingPeriod : null} onChange={() => {}} required={on_payment === true ? true : false} />
                    <Form.Control.Feedback type="invalid">* Please Select Billing Period</Form.Control.Feedback>
                  </Form.Group>
                  <div>
                    <Form.Group className={`${style.hr} mt-2 mb-3`}></Form.Group>
                  </div>
                  {selectPlan.value === "custom" && (
                    <>
                      {/* custom modules and themes  */}
                      <Col lg="12" className="mb-2 ">
                        <Form.Group className="w-100" controlId="formBasicShopName">
                          <Form.Label> Associated Modules</Form.Label>
                          <div className="d-flex gap-3 flex-wrap">
                            {modulesOptions
                              .filter((item) => !modulesNotShow.includes(item.name))
                              .map((item, index) => (
                                <div style={{ border: "1px solid aliceblue" }} className="d-flex flex-column  ">
                                  <div style={{ maxHeight: "50px" }} onClick={() => fetchSubModulesData(index)} className=" mb-2 d-flex gap-3 p-2 bg-light align-items-center ">
                                    <Form.Check
                                      key={index}
                                      className={""}
                                      onChange={(e) => {
                                        handleCheckboxChange(e, item?.name);
                                      }}
                                      name={item?.name}
                                      checked={item.checked}
                                      required={modulesOptions.filter((item) => item.checked).length === 0}
                                      disabled={item?.disabled}
                                      type="checkbox"
                                      id={`${index}`}
                                    />
                                    <label
                                    //  htmlFor={`${index}`}
                                    >
                                      {item.name}
                                    </label>
                                  </div>
                                  <Form.Group className="w-100" controlId="formBasicShopName">
                                    <div className="d-grid ms-2 ">
                                      {item?.submodulesArray
                                        ?.filter((item) => !modulesNotShow.includes(item.name))
                                        .map((sItem, i) => (
                                          <Form.Check
                                            key={i}
                                            className={""}
                                            onChange={(e) => {
                                              handleSubmoduleCheckboxChange(e, sItem.name, item.name);
                                            }}
                                            required={modulesOptions.filter((item) => item.checked).length === 0}
                                            name={sItem.name}
                                            checked={sItem.checked}
                                            type="checkbox"
                                            id={`${index}-${sItem.name}`}
                                            label={`${sItem.name}`}
                                          />
                                        ))}
                                    </div>
                                  </Form.Group>
                                </div>
                              ))}
                          </div>
                        </Form.Group>
                      </Col>
                      {modulesOptions.find((module) => module.name === "Marketplace")?.checked && (
                        <Form.Group className="w-100" controlId="formBasicShopName">
                          <Form.Label> Associated Themes</Form.Label>
                          <SearchableSelect
                            searchable={false}
                            multiselect={true}
                            value={customForm.themes}
                            options={ThemeOptions}
                            name=""
                            handleChange={(e) => handleSelectPlanChange(e, "themes")}
                            // options={}
                          />
                          <Form.Control value={customForm.themes} onChange={() => {}} hidden required />
                          <Form.Control.Feedback type="invalid">Please select Theme.</Form.Control.Feedback>
                        </Form.Group>
                      )}

                      {modulesOptions.find((module) => module.name === "Marketplace")?.checked && (
                        <Col md={6} className="py-2">
                          <Form.Group className="w-100" controlId="formBasicShopName">
                            <label>
                              MarketPlace Items Limit <span className="text-danger">*</span>
                            </label>
                            <Form.Control
                              value={customForm.itemsLimit}
                              name="itemsLimit"
                              onChange={(e) => {
                                handlePlanChange(e);
                                // setItemsLimit(e.target.value.replace(/\D/g, ""));
                              }}
                              type="number"
                              placeholder="eg.1000"
                              required
                            />
                            <Form.Control.Feedback type="invalid">Please Enter value.</Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      )}
                      {/* <Form.Group className="mb-3" as={Col} lg="6" md="6" sm="12">
                        <label className="mb-1">
                          Plan Amount <span className="text-danger">*</span>
                        </label>
                        <Form.Control className="p-2" placeholder="Rs. 1000" name="plan" type="text" value={planAmount} onChange={(e) => setPlanAmount(e.target.value.replace(/\D/g, ""))} required={selectPlan.value === "custom" ? true : false} />
                        <Form.Control.Feedback type="invalid">* Please Enter Plan Amount</Form.Control.Feedback>
                      </Form.Group> */}
                      <Col md={6} className="py-2">
                        <Form.Group className="w-100" controlId="formBasicShopName">
                          <label>
                            Emails Limit <span className="text-danger">*</span>
                          </label>
                          <Form.Control
                            value={customForm.emailsLimit}
                            name="emailsLimit"
                            onChange={(e) => {
                              handlePlanChange(e);
                              // setEmailsLimit(e.target.value.replace(/\D/g, ""));
                            }}
                            type="number"
                            placeholder="eg.1000"
                            required
                          />
                          <Form.Control.Feedback type="invalid">Please Enter value.</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col className="py-2" lg="6">
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label className="mb-1">
                            Secondary User <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            required
                            onChange={(e) => {
                              handlePlanChange(e);
                            }}
                            placeholder="Enter secondary user"
                            name="secondaryUser"
                            value={customForm.secondaryUser}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="py-2">
                        <Form.Group className="w-100" controlId="formBasicShopName">
                          <label>
                            Locations Limit <span className="text-danger">*</span>
                          </label>
                          <Form.Control
                            value={customForm.locationLimit}
                            name="locationLimit"
                            onChange={(e) => {
                              handlePlanChange(e);
                              // setLocationLimit(e.target.value.replace(/\D/g, ""));
                            }}
                            type="number"
                            placeholder="eg.1000"
                            required
                          />
                          <Form.Control.Feedback type="invalid">Please Enter value.</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col className="py-2" md={6}>
                        <Form.Group className="mb-3" controlId="price">
                          <label>
                            Sms Limit <span className="text-danger">*</span>
                          </label>
                          <Form.Control
                            value={customForm.smsLimit}
                            name="smsLimit"
                            onChange={(e) => {
                              handlePlanChange(e);
                              // setSmsLimit(e.target.value.replace(/\D/g, ""));
                            }}
                            type="number"
                            placeholder="eg.1000"
                            required
                          />
                          <Form.Control.Feedback type="invalid">Please Enter value.</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="12" className="py-2 d-flex justify-content-center ">
                        <Button onClick={calculate} className="w-75" variant="secondary">
                          Calculate
                        </Button>
                      </Col>
                      {/* <Form.Group className="mb-3" as={Col} lg="6" md="6" sm="12">
                        <label className="mb-1">
                          MarketPlace Items Limit <span className="text-danger">*</span>
                        </label>
                        <Form.Control className="p-2" placeholder="eg. 1000" name="plan" type="text" value={itemsLimit} onChange={(e) => setItemsLimit(e.target.value.replace(/\D/g, ""))} required={selectPlan.value === "custom" ? true : false} />
                        <Form.Control.Feedback type="invalid">* Please Enter MarketPlace Items Limit</Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="mb-3" as={Col} lg="6" md="6" sm="12">
                        <label className="mb-1">
                          Emails Limit <span className="text-danger">*</span>
                        </label>
                        <Form.Control className="p-2" placeholder="eg. 1000" name="plan" type="text" value={emailsLimit} onChange={(e) => setEmailsLimit(e.target.value.replace(/\D/g, ""))} required={selectPlan.value === "custom" ? true : false} />
                        <Form.Control.Feedback type="invalid">* Please Enter Emails Limit</Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="mb-3" as={Col} lg="6" md="6" sm="12">
                        <label className="mb-1">
                          Locations Limit <span className="text-danger">*</span>
                        </label>
                        <Form.Control className="p-2" placeholder="eg. 1000" name="plan" type="text" value={locationLimit} onChange={(e) => setLocationLimit(e.target.value.replace(/\D/g, ""))} required={selectPlan.value === "custom" ? true : false} />
                        <Form.Control.Feedback type="invalid">* Please Enter Locations Limit</Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="mb-3" as={Col} lg="6" md="6" sm="12">
                        <label className="mb-1">
                          Sms Limit <span className="text-danger">*</span>
                        </label>
                        <Form.Control className="p-2" placeholder="eg. 1000" name="plan" type="text" value={smsLimit} onChange={(e) => setSmsLimit(e.target.value.replace(/\D/g, ""))} required={selectPlan.value === "custom" ? true : false} />
                        <Form.Control.Feedback type="invalid">* Please Enter Sms Limit</Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="mb-3" as={Col} lg="6" md="6" sm="12">
                        <label className="mb-1">
                          Secondary Users Limit <span className="text-danger">*</span>
                        </label>
                        <Form.Control className="p-2" placeholder="eg. 1000" name="plan" type="text" value={secondaryUsersLimit} onChange={(e) => setSecondaryUsersLimit(e.target.value.replace(/\D/g, ""))} required={selectPlan.value === "custom" ? true : false} />
                        <Form.Control.Feedback type="invalid">* Please Enter Secondary Users Limit</Form.Control.Feedback>
                      </Form.Group> */}
                      <Form.Group className="mb-3" as={Col} lg="6" md="6" sm="12">
                        <label className="mb-1 text-capitalize">
                          Plan Amount <span className="text-danger">*</span>
                        </label>
                        <Form.Control
                          className="p-2"
                          disabled
                          placeholder="Rs. 1000"
                          name="plan"
                          type="text"
                          value={monthlyTotal}
                          // value={billingPeriod.value === "yearly" ? Math.round(yearlyTotal) : billingPeriod.value === "quarterly" ? Math.round(quarterlyTotal) : Math.round(semiannualTotal)}
                          onChange={() => {}}
                          required={selectPlan.value === "custom" ? true : false}
                        />
                        <Form.Control.Feedback type="invalid">* Please Enter Plan Amount</Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="mb-3" as={Col} lg="6" md="6" sm="12">
                        <label className="mb-1 text-capitalize">
                          {billingPeriod.value} Total <span className="text-danger">*</span>
                        </label>
                        <Form.Control
                          className="p-2"
                          disabled
                          placeholder="Rs. 1000"
                          name="plan"
                          type="text"
                          value={billingPeriod.value === "yearly" ? yearlyTotal : billingPeriod.value === "quarterly" ? quarterlyTotal : semiannualTotal}
                          onChange={() => {}}
                          required={selectPlan.value === "custom" ? true : false}
                        />
                        <Form.Control.Feedback type="invalid">* Please Enter {billingPeriod.value} Total</Form.Control.Feedback>
                      </Form.Group>
                    </>
                  )}
                </>
              )}
            </Row>
            <div className={`${style.fullWidth} m-0`}>
              <Form.Label>
                Upload Logo <span className="text-secondary">(Optional)</span>
              </Form.Label>
              <ImageUploader ref={ImageRef} selectedFiles={image} setSelectedFiles={setImage} />
            </div>
            <div className={`mb-4 ${style.fullWidth}`}>
              <Button className="w-100" type="submit" disabled={isClicked}>
                {isClicked ? <Loader /> : "Register Shop"}
              </Button>
            </div>
          </Form>
        </FormCard>
      </div>
    </div>
  );
};
export default RegisterShop;
